<main class="w-full">
	<div class="ff-row-form ff-grid-margin ml-[10px]">
		<div class="inline-flex items-center mb-[12px]">
			@if (false) {
				<div class="h-1 w-1 rounded ml-[8px] mr-[8px]"></div>
			}
			<p class="text-font text-xs">Painel Somatório (LBCA)</p>
		</div>
	</div>
	<!--
  <div class="ff-row-form ff-grid-margin ml-[18px]">
    <div class="w-[30%]"></div>
    <div class="w-[200px]"><label class="text-font text-xs">LBCA</label></div>
    <div class="w-[30%]"></div>
    <div class="w-[200px]"><label class="text-font text-xs">LBCA</label></div>
  </div> -->
	<!--  -->

	@for (row of baseDepositos; track row) {
		<div class="ff-row-form ff-grid-margin ml-[18px]">
			@for (col of row; track col) {
				<div [style.width.%]="100 / row.length">
					<lbca-input-text
						[disabled]="true"
						[label]="col.label"
						[copyContent]="false"
						[referenced]="true"
						[maskInput]="'CURRENCY_BR'"
						[value]="col.value"
					></lbca-input-text>
				</div>
			}
		</div>
	}
</main>
